export const getMonth = month => {
    switch (month) {
        case '01':
            return 'Jan';
        case '02':
            return 'Feb';
        case '03':
            return 'Mar';
        case '04':
            return 'Apr';
        case '05':
            return 'May';
        case '06':
            return 'Jun';
        case '07':
            return 'Jul';
        case '08':
            return 'Aug';
        case '09':
            return 'Sep';
        case '10':
            return 'Oct';
        case '11':
            return 'Nov';
        case '12':
            return 'Dec';
        default:
            break;
    }
};

export const dealTime = dayNum => {
    let day = '';

    switch (dayNum) {
        case 0:
            day = '星期日';
            break;
        case 1:
            day = '星期一';
            break;
        case 2:
            day = '星期二';
            break;
        case 3:
            day = '星期三';
            break;
        case 4:
            day = '星期四';
            break;
        case 5:
            day = '星期五';
            break;
        case 6:
            day = '星期六';
            break;
        default:
            day = '星期数错误！';
    }

    return day;
};
/**
 *
 * @param {*} time  sever time, eg: "2019/03/12 10:06:00"
 * @param {*} type  the type of time u need
 */
export const handleTime = (time, type) => {
    time = time ? time : `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`;
    switch (type) {
        case 'ymd':
            return time.substring(0, 10);
        case 'year':
            return time.substring(0, 4);
        case 'month':
            return time.substring(5, 7);
        case 'date':
            return time.substring(8, 10);
        default:
            // 09:18 hour:minute
            return time.substring(11, 16);
    }
};

/**
 * @param {int} dateTimeStamp
 * @return {string} 格式化返回相对于当前时间多久之前
 */
export const getTimeFormal = dateTimeStamp => {
    const minute = 1000 * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;

    if (dateTimeStamp === undefined) {
        return null;
    } else {
        const sTime = new Date(dateTimeStamp).getTime();
        const now = new Date().getTime();
        const diffValue = now - sTime;

        if (diffValue < 0) {
            console.log('结束日期不能小于开始日期！');
        }

        const monthC = diffValue / month;
        const weekC = diffValue / (7 * day);
        const dayC = diffValue / day;
        const hourC = diffValue / hour;
        const minC = diffValue / minute;

        if (monthC >= 1) {
            return `${parseInt(monthC)}月前`;
        } else if (weekC >= 1) {
            return `${parseInt(weekC)}周前`;
        } else if (dayC >= 1) {
            return `${parseInt(dayC)}天前`;
        } else if (hourC >= 1) {
            return `${parseInt(hourC)}小时前`;
        } else if (minC >= 1) {
            return `${parseInt(minC)}分钟前`;
        } else {
            return '刚刚';
        }
    }
};
